var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKlaytn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 120,
    viewBox: "0 0 280 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8994 59.9418L91.6592 80.634C96.7563 75.2331 99.8618 67.9419 99.8618 59.9418C99.8618 51.9417 96.7563 44.6504 91.6592 39.2495L70.8994 59.9418Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4477 61.3589L48.958 81.7811L69.4477 90.22L89.9375 81.7811L69.4477 61.3589Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7054 59.1987L89.9378 38.0676L70.3932 30L50.8486 77.0217L68.7054 59.1987Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 59.9409C39 67.9072 42.1055 75.1647 47.1351 80.5656L67.5236 31.5186L39 59.9409Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.421 54.1357C226.986 54.1357 224.995 58.1527 224.995 58.1527V54.6083H220.944V78.2036H224.995V62.7772C224.995 60.6844 226.952 57.7476 231.273 57.7476C235.29 57.7476 237.518 60.178 237.518 64.6V78.2036H241.569V63.8911C241.535 57.9839 237.957 54.1357 232.421 54.1357Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.478 46.7769H206.428V51.4689C206.428 53.1905 205.01 54.6082 203.288 54.6082H198.731L191.204 72.7013L183.676 54.6082H179.524L189.145 77.7309L186.681 83.7056H181.381V87.2162H185.499C187.862 87.2162 189.955 85.7985 190.866 83.6381L201.466 58.1525H206.461V72.2287C206.461 75.8743 208.622 78.2034 211.964 78.2034H217.533V74.6928H210.478V58.1525H217.533V54.6082H210.478V46.7769V46.7769Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.96 62.7097C176.96 57.4438 173.179 54.1357 167.137 54.1357C161.533 54.1357 157.618 57.6126 156.875 63.1148H160.824C161.668 59.0303 164.504 57.5451 167.035 57.5451C170.715 57.5451 172.943 59.6042 172.943 63.081V64.6675H167.373C159.542 64.6675 156.166 67.1654 156.166 71.4524C156.166 75.8407 159.643 78.5411 165.111 78.5411C169.5 78.5411 172.031 76.9209 173.179 74.3554C173.483 76.5158 174.698 78.1698 177.837 78.1698H180.504V74.6255H176.993V62.7097H176.96ZM172.909 71.2499C172.909 73.6465 169.938 75.5369 165.786 75.5369C162.445 75.5369 160.385 74.2542 160.385 71.8575V70.9123C160.385 68.6507 162.546 67.4017 167.339 67.4017H172.909V71.2499Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.719 45.0552H145.668V72.1948C145.668 75.8404 147.828 78.1695 151.17 78.1695H153.229V74.6589H149.685V45.0552H149.719Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.972 45.0552H117.921V78.1695H121.972V45.0552Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.866 45.0552H137.837L125.347 57.511C124.166 58.6925 124.064 60.549 125.111 61.8655L138.174 78.1695H143.271L128.351 59.5364L142.866 45.0552Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaytn);
export default __webpack_public_path__ + "static/media/Klaytn.ced068628dd77b8a73b173eff238e8f4.svg";
export { ForwardRef as ReactComponent };